export default __webpack_public_path__ + "static/media/spin-bg-13.0be6b04d.png";